import {fr} from '../translate/fr';
import {en} from '../translate/en';

/**
 * -----------
 * Translate
 * -----------
 * usage: Translate.print(json.path)
 */
export default class Translate {

    /** récupèration de la langue sélectionnée */
    static language;

    /** variables intermédiaires utilisées dans la fonction eval() */
    static langEn = en;
    static langFr = fr;

    constructor() {
        Translate.init();
        Translate.setLanguage();
    }

    /**
     * ---------------
     * init
     * ---------------
     * Initialise le service de traduction
     */
    static init () {
        if( window.localStorage.getItem( 'language') ) {
            Translate.language = window.localStorage.getItem( 'language');
            $( '.glink[title=' + Translate.language + ']' ).addClass('active');
        } else {
            window.localStorage.setItem( 'language', 'French' );
            Translate.language = 'French';
            $( '.glink[title=French]' ).addClass('active');
        }
    }

    /**
     * ---------------
     * setLanguage
     * ---------------
     * Permet de sélectionner une langue, recharge la current page
     */
    static setLanguage () {
        $( document ).on('click', '.glink', function() {
            if( window.localStorage.getItem( 'language') !== $( this ).attr('title') ) {
                window.localStorage.setItem( 'language', $( this ).attr('title') );
                setTimeout(function() {
                    document.location.reload();
                }, 200);
            }
            $( '.glink' ).removeClass('active');
            $( this ).addClass('active');
        });
    }

    /**
     * ---------------
     * print
     * ---------------
     * Retourne la chaîne de caractère correspondante à la langue sélectionnée
     */
    static print (string) {
        const str = '';
        if( Translate.language === undefined ) {
            Translate.language = window.localStorage.getItem('language');
        }

        switch (Translate.language) {
            case 'French':
                eval( "str = Translate.langFr." + string );
                break;
            case 'English':
                eval( "str = Translate.langEn." + string );
                break;
            default:
                eval( "str = Translate.langFr." + string );
                break;
        }

        return str;
    }
}